import { IPaginatedQuery } from '@monorepo/components';

import { ApiResponse, ApiResponseWithPagination } from '@/types';
import { IFaq, IFaqCategory } from '@/types/entities/faq.entities';

import http from '../http';

export const getAllFaqsById = async (payload: IPaginatedQuery) => {
  const queryParams = new URLSearchParams({
    page: payload.page.toString(),
    limit: payload.limit.toString(),
    sortBy: payload.sortBy || '',
    sortOrder: payload.sortOrder || 'asc',
  });

  if (payload?.categoryId) {
    queryParams.append('categoryId', payload.categoryId as string);
  }

  if (payload?.search) {
    queryParams.append('search', payload.search as string);
  }

  return http.get<ApiResponseWithPagination<IFaq, 'docs'>>(`/faqs?${queryParams}`);
};

export const getAllFaqsCategory = async () =>
  http.get<ApiResponse<IFaqCategory[]>>('/faq-categories');
